import { LoginView as BaseLoginView } from "../smart_bps/auth/login"
import { PROJECT_NAME } from "./constants"
import { wrapView } from '../smart_bps/lib/utils'
import { Link, Navigate } from 'react-router-dom'
import AttrInput from '../smart_bps/lib/attr_input'
import { stateToProps } from '../smart_bps/bps/base_view'
import { request } from "../smart_bps/lib/utils"
import { store } from "../index"

class LoginView extends BaseLoginView {
    onSubmit() {
      request({
        method: 'post',
        url: '/api/auth/token',
        requestType: "form",
        data: new URLSearchParams(this.state.form_data),
        success: (data) => {
          localStorage.setItem('auth_access_token', data.access_token)
          localStorage.setItem('auth_refresh_token', data.refresh_token)
          localStorage.setItem('auth_refresh_url', data.refresh_url)

          store.dispatch({ type: 'auth_authenticated', data })
        },
      })
    }

    render() {
        if (this.authorized) {
            return <Navigate to="/" replace={true} state={null} />
        }

        const form_data = this.state.form_data

        return (
            <div className="container-xxl">
                <div className="authentication-wrapper authentication-basic container-p-y">
                    <div className="authentication-inner py-4">
                        <div className="card">
                            <div className="card-body">
                                <div className="app-brand justify-content-center mb-4 mt-2">
                                    <a href="/" className="app-brand-link gap-2">
                                        <span className="app-brand-text demo text-body fw-bold ms-1">
                                            <i className="ti ti-planet me-2"></i>
                                            Добро пожаловать
                                        </span>
                                    </a>
                                </div>
                                <p className="mb-4 text-center">Необходимо войти в систему</p>
                                <div className="mb-3 fv-plugins-icon-container">
                                    <AttrInput data_type="string" name="username" placeholder="Email" onChange={this.formChange} value={form_data.username} />
                                </div>
                                <div className="mb-3 form-password-toggle fv-plugins-icon-container">
                                    <AttrInput data_type="password" name="password" placeholder="Пароль" onChange={this.formChange} value={form_data.password} />
                                </div>
                                <div className="mb-3">
                                    <button className="btn btn-primary d-grid w-100 waves-effect waves-light" onClick={this.onSubmit}>
                                        Вперед
                                    </button>
                                </div>
                                <div className="divider my-2">
                                    <div className="divider-text">или</div>
                                </div>
                                <div className="d-flex justify-content-center">
                                    <Link className="me-2" to="/">Домой</Link> | <Link className="ms-2" to="/auth/restore_password/">Напомнить пароль</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default wrapView(LoginView, (state) => {
    return stateToProps(state, PROJECT_NAME)
})

